import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import * as actions from '../ChallengePage/actions';
import { useActions } from 'hooks/useActions';
import { Container } from '../../components';
import { RankList } from '../../components/rankList/rankList';
import { ContentContainer, RankListContainer } from '../ChallengePage/styles';
import { ChallengeName, Wrapper, Logo, HeaderContainer, CenteringWrapper } from './styles';
import { Images } from 'util/images';

export default function Hackathon() {
  const params = useParams();
  const id = params.id;
  const { getChallenge } = useActions(actions);

  const { selectedChallenge } = useSelector((state) => state.challenge);

  useEffect(() => {
    getChallenge(id, 'challenges');
  }, [getChallenge, id]);

  const renderTopList =
    selectedChallenge.rankList && selectedChallenge.rankList.length ? (
      <CenteringWrapper>
        <Container column full>
          <ContentContainer center>
            <RankListContainer>
              <RankList
                isTournament={selectedChallenge.isTournament}
                rankList={selectedChallenge.rankList}
                isHackathon
              />
            </RankListContainer>
          </ContentContainer>
        </Container>
      </CenteringWrapper>
    ) : (
      <p>No top list</p>
    );
  return (
    <CenteringWrapper>
      <Wrapper full column center padding>
        <HeaderContainer>
          <Logo src={Images.logoBlue} />
          <ChallengeName>{selectedChallenge.name}</ChallengeName>
          <Logo src={selectedChallenge?.landingPageLogo ?? ''} />
        </HeaderContainer>
        {renderTopList}
      </Wrapper>
    </CenteringWrapper>
  );
}
